import ColumnTypes from '@/utils/ColumnTypes';
import { isShallow } from 'vue';

const colonelActivitySquare = {
	key: 'colonelActivitySquare',
	label: '商品信息',
	type: ColumnTypes.channelShopCell,
    minWidth: '400',
	maxWidth: 'unset',
	fixed: 'left',
};
// 活动佣金率
const activityCommissionRate = {
	key: 'commission_rate',
	label: '活动佣金率',
	type: ColumnTypes.TextCell,
	minWidth: '100',
};
const activityServiceRate = {
	key: 'activityServiceRate',
	label: '活动服务费率',
	type: ColumnTypes.TextCell,
	minWidth: '120',
};
const activityServiceRateInput = {
	key: 'activityServiceRateInput',
	label: '活动服务费率',
	type: () => import('./ksTableCell/serviceRateInputCell.vue'),
	minWidth: '120',
	required: true,
};
const adActivityServiceRateInput = {
	key: 'adActivityServiceRateInput',
	label: '投放期服务费率',
	type: () => import('./ksTableCell/adServiceRateInputCell.vue'),
	minWidth: '120',
	required: true,
};
const promotionEndTime = {
	key: 'promotionEndTime',
	label: '推广结束时间',
	type: ColumnTypes.TextCell,
	minWidth: '150',
};
const promotionEndTimeInput = {
	key: 'promotionEndTimeInput',
	label: '推广结束时间',
	type: () => import('./ksTableCell/promotionEndTimeInputCell.vue'),
	minWidth: '150',
	required: true,
};
const contactPhone = {
	key: 'contactPhone',
	label: '联系电话',
	type: ColumnTypes.TextCell,
	minWidth: '120',
};
const contactPhoneInput = {
	key: 'contactPhoneInput',
	label: '联系电话',
	type: () => import('./ksTableCell/contactPhoneInputCell.vue'),
	minWidth: '120',
	required: true,
};
export const columnsWithText = [colonelActivitySquare, activityCommissionRate];
export const columnsWithInput = [colonelActivitySquare, activityCommissionRate, activityServiceRateInput, promotionEndTimeInput, contactPhoneInput];
export const adColumnsWithInput = [colonelActivitySquare, activityCommissionRate, activityServiceRateInput, adActivityServiceRateInput, promotionEndTimeInput, contactPhoneInput];
